export const AccessFormField = {
  role: 'role',
  isFinancialReportAvailable: 'isFinancialReportAvailable',
  isRecipientForMonthlyFinancialReport: 'isRecipientForMonthlyFinancialReport',
} as const;
